import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { HeaderModule } from '../../component/common/header/header.module';
import { LabelModule } from '../../component/common/label/label.module';
import { DetailsComponent } from './details.component';

@NgModule({
  imports: [
    IonicModule,
    CommonModule,
    HeaderModule,
    LabelModule,
  ],
  declarations: [DetailsComponent]
})
export class DetailsModule {}
